import React, { useState } from 'react';

interface FileIconProps {
  language: string;
  size?: number;
}

export const FileIcon: React.FC<FileIconProps> = ({ language, size = 16 }) => {
  const getIcon = (lang: string) => {
    const icons: Record<string, string> = {
      typescript: '𝐓𝐒',
      javascript: '𝐣𝐬',
      json: '{ }',
      css: '𝐂',
      html: '𝐇',
      markdown: '𝐌',
      python: '𝐏𝐲',
      java: '𝐉',
      cpp: '⧺',
      csharp: '𝐂#',
      go: '𝐆𝐨',
      rust: '𝐑',
      ruby: '💎',
      php: '𝐏𝐇𝐏',
    };
    return icons[lang.toLowerCase()] || '📄';
  };

  return (
    <span className="file-icon" style={{ fontSize: size }}>
      {getIcon(language)}
    </span>
  );
};

interface StatusIndicatorProps {
  isDirty: boolean;
  isModified: boolean;
  isPinned: boolean;
}

export const StatusIndicator: React.FC<StatusIndicatorProps> = ({
  isDirty,
  isModified,
  isPinned,
}) => {
  const [showPopover, setShowPopover] = useState(false);

  // Priority: Unsaved > Modified > Pin
  let indicator: string | null = null;
  let color = '';

  if (isDirty) {
    indicator = '●';
    color = 'red';
  } else if (isModified) {
    indicator = '●';
    color = 'orange';
  } else if (isPinned) {
    indicator = '📌';
  }

  if (!indicator) return null;

  return (
    <div className="status-indicator" onClick={() => setShowPopover(!showPopover)}>
      <span style={{ color }}>{indicator}</span>
      {showPopover && (
        <div className="status-popover">
          {isDirty && <div>Unsaved changes</div>}
          {isModified && <div>Modified (Git)</div>}
          {isPinned && <div>Pinned</div>}
        </div>
      )}
    </div>
  );
};